import HyperlinkKpiSales from "@/components/functionals/HyperlinkKpiSales";
import HyperlinKpiSalesTotal from "@/components/functionals/HyperlinKpiSalesTotal";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";

import {
  formatDate

  // FormatPercentSalesKpi,
} from "../utils";
export const Months = [
  {
    prop: "JanuaryPercentaje",
    name: "Enero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "FebruaryPercentaje",
    name: "Febrero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "MarchPercentaje",
    name: "Marzo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "AprilPercentaje",
    name: "Abril",
    minWidth: 80,
    aling: "center",
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "MayPercentaje",
    name: "Mayo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "JunePercentaje",
    name: "Junio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "JulyPercentaje",
    name: "Julio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "AugustPercentaje",
    name: "Agosto",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkKpiSales
  },
  {
    prop: "SeptemberPercentaje",
    name: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSales
  },
  {
    prop: "OctoberPercentaje",
    name: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSales
  },
  {
    prop: "NovemberPercentaje",
    name: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSales
  },
  {
    prop: "DecemberPercentaje",
    name: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSales
  },
  {
    prop: "Totales",
    name: "Total",
    minWidth: 80,
    fixed: true,
    formatter: HyperlinKpiSalesTotal
  }
];

export const PaymentDetails = [
  {
    prop: "Date",
    label: "Fecha",
    minWidth: 110,
    fixed: true,
    formatter: CellDateTime
  },

  {
    prop: "CustomerNo",
    label: "COD.",
    minWidth: 80,
    fixed: true
  },
  {
    prop: "CustomerName",
    label: "Cliente",
    minWidth: 200,
    fixed: true
  },
  {
    prop: "AmountFormat",
    label: "Monto",
    minWidth: 80,
    fixed: true
  },
  {
    prop: "TipoContrato",
    label: "Facturación",
    minWidth: 100,
    fixed: true
  },
  {
    prop: "Qty",
    label: "Equipos",
    minWidth: 80,
    fixed: true
  },
  {
    prop: "Contract",
    label: "Contrato",
    minWidth: 80,
    fixed: true
  },
  {
    prop: "Service",
    label: "Servicio",
    minWidth: 250,
    fixed: true
  }
];
export const commentColumns = [
  {
    prop: "user",
    label: "Usuario",
    minWidth: 50,
    fixed: true
  },
  {
    prop: "Fecha",
    label: "Fecha",
    minWidth: 50,
    fixed: true,
    sortable: true,
    formatter: (row) => formatDate(row.Fecha, "DD/MM/yyyy")
  },
  {
    prop: "Comment",
    label: "Comentario",
    minWidth: 200
  }
];
